import React, { memo } from 'react'
import {
  experimentalStyled,
  Container,
  Box,
  Toolbar,
  Grid,
  Stack
} from '@mui/material'
import { Link, Routes, Route } from 'react-router-dom'
import { HashLink } from 'react-router-hash-link'

import CommunitySaleContainer from './containers/CommunitySaleContainer'
import LeaderboardContainer from './containers/LeaderboardContainer'
import { CONTAINER_MIN_HEIGHT } from './styles/common'
import WalletConnectButtonWrapper from './components/walletConnect/WalletConnectButtonWrapper'
import qbFoundationLogo from './assets/logos/qiibee-foundation-logo.png'
import HeaderLinkText from './components/shared/text/HeaderLinkText'
import {
  HOME_URL,
  LEADERBOARD_URL,
  PRIVACY_POLICY_URL,
  TERMS_CONDITIONS_URL
} from './constants/navigation'
import FooterLinks from './components/layout/FooterLinks'
import TermsAndConditions from './components/layout/TermsAndConditions'
import PrivacyPolicy from './components/layout/PrivacyPolicy'

const App = ({ t, onClickRefresh, mainProfile, mainDispatch, saleEnded }) => {
  const navigationItems = [
    { label: t('home.home'), to: HOME_URL },
    { label: t('home.leaderboard'), to: LEADERBOARD_URL }
  ]
  return (
    <MainWrapper>
      <PageWrapper>
        <Container maxWidth={false}>
          <Toolbar sx={{ mb: { md: 3, xs: 1 }, mt: 2 }} disableGutters>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={6}>
                <Box
                  sx={{ margin: 'auto' }}
                  textAlign={{ sm: 'left', xs: 'center' }}
                >
                  <Link to={HOME_URL}>
                    <img
                      src={qbFoundationLogo}
                      height='43'
                      alt={t('home.welcome-text')}
                    />
                  </Link>
                </Box>
              </Grid>
              <Grid
                item
                xs={12}
                sm={6}
                textAlign={{ sm: 'right', xs: 'center' }}
              >
                <Stack
                  direction={{ xs: 'column', md: 'row' }}
                  spacing={4}
                  alignItems='center'
                  justifyContent='flex-end'
                >
                  {navigationItems.map(({ label, to }, index) => (
                    <HeaderLinkText
                      key={index}
                      component={Link}
                      to={to}
                      label={label}
                    />
                  ))}
                  <HashLink
                    to={HOME_URL}
                    elementId='faqs'
                    style={{ textDecoration: 'none' }}
                  >
                    <HeaderLinkText label={t('home.faqs')} />
                  </HashLink>
                  <WalletConnectButtonWrapper t={t} />
                </Stack>
              </Grid>
            </Grid>
          </Toolbar>
          <Box sx={CONTAINER_MIN_HEIGHT}>
            <Routes>
              <Route
                path={HOME_URL}
                element={
                  <CommunitySaleContainer
                    onClickRefresh={onClickRefresh}
                    mainProfile={mainProfile}
                    mainDispatch={mainDispatch}
                    saleEnded={saleEnded}
                  />
                }
              />
              <Route
                path={LEADERBOARD_URL}
                element={<LeaderboardContainer mainProfile={mainProfile} />}
              />
              <Route
                path={TERMS_CONDITIONS_URL}
                element={<TermsAndConditions t={t} mainProfile={mainProfile} />}
              />
              <Route
                path={PRIVACY_POLICY_URL}
                element={<PrivacyPolicy t={t} />}
              />
            </Routes>
          </Box>
          <FooterLinks t={t} />
        </Container>
      </PageWrapper>
    </MainWrapper>
  )
}

export default memo(App)

const MainWrapper = experimentalStyled('div')(() => ({
  display: 'flex',
  minHeight: '100vh',
  overflow: 'hidden',
  width: '100%'
}))

const PageWrapper = experimentalStyled('div')(({ theme }) => ({
  display: 'flex',
  flex: '1 1 auto',
  overflow: 'hidden',
  backgroundColor: theme.palette.background.default
  // [theme.breakpoints.down('lg')]: {
  //   paddingTop: '70px'
  // }
}))
